import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { setupNavigation } from "../../redux/actions/navItemsActions";
import { getRecentGroups } from "../../redux/actions/groupActions";
import { loadUpcomingUserEvents } from "../../redux/actions/eventActions";
import PropTypes from "prop-types";
import PostFeedControl from "../postComments/PostFeedControl";
import "./profile/ProfilePage.css";

function DashboardPage(
    {
        getRecentGroups,
        loadUpcomingUserEvents,
        setupNavigation
    }
) {
    const [interestingGroups, setInterestingGroups] = useState({});
    const [interestingEvents, setInterestingEvents] = useState({});

    const navigationItems =
    {
        sections: [{
            name: 'Routes',
            showTitle: true,
            items: [
                {
                    path: '/user/routes',
                    text: 'My Routes',
                    icon: 'fas fa-route'
                },
                {
                    path: '/user/bookmarks',
                    text: 'Bookmarked Routes',
                    icon: 'fas fa-star'
                }
            ]
        },
        interestingEvents,
        interestingGroups,
        {
            name: 'Settings',
            items: [
                {
                    path: '/user/settings/general',
                    text: 'Settings',
                    icon: 'fas fa-cog'
                }
            ]
        }]
    };

    useEffect(() => {
        document.title = "JustGoRide";
        setupNavigation(navigationItems);
        getPopularGroups();
        getUpcomingEvents();
    }, []);

    useEffect(() => {
        setupNavigation(navigationItems);
    }, [interestingGroups, interestingEvents])

    function getUpcomingEvents() {
        loadUpcomingUserEvents(5).then((events) => {
            var items = [];
            events.map(e => {
                items.push({
                    path: `/events/${e.id}`,
                    text: e.name,
                    avatar: { type: 'groups', available: e.groupHasAvatar, id: e.groupId }
                })
            })
            items.push({
                path: '/events',
                text: 'See all Events',
                icon: 'far fa-calendar-alt'
            })
            var navSection = {
                name: 'Upcoming Events',
                showTitle: true,
                items: items
            };
            setInterestingEvents(navSection);
        })
    }

    function getPopularGroups() {
        getRecentGroups().then((groups) => {
            var items = [];
            groups.map(g => {
                items.push({
                    path: `/groups/${g.id}`,
                    text: g.name,
                    avatar: { type: 'groups', available: g.avatarAvailable, id: g.id }
                })
            })
            items.push({
                path: '/groups',
                text: 'See all Groups',
                icon: 'fas fa-users'
            })
            var navSection = {
                name: 'Groups',
                showTitle: true,
                items: items
            };
            setInterestingGroups(navSection);
        })
    }

    return (
        <PostFeedControl mode={"News"} />           
    );


}

DashboardPage.propTypes = {
    getRecentGroups: PropTypes.func.isRequired,
    loadUpcomingUserEvents: PropTypes.func.isRequired,
    setupNavigation: PropTypes.func.isRequired
}

function mapStateToProps(state) {
    return {
    };
}

const mapDispatchToProps = {
    getRecentGroups,
    loadUpcomingUserEvents,
    setupNavigation
}

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);



// WEBPACK FOOTER //
// ./src/components/user/DashboardPage.js